import {
  ICompanyDigitalCertificate,
  ICompanyDigitalCertificateList,
  INewCompanyDigitalCertificate,
} from "../models/company-digital-certificate";
import { GlobalAxios } from "../axios/axios-config";

const COMPANY_DIGITAL_CERTIFICATE_SERVICE =
  process.env.REACT_APP_MAIN + "/api/v1/CompanyDigitalCertificate/";

export const createCompanyDigitalCertificate = (
  item: INewCompanyDigitalCertificate,
) => {
  return GlobalAxios.post(COMPANY_DIGITAL_CERTIFICATE_SERVICE, item);
};

export const getCompanyDigitalCertificateById = (id: string) => {
  return GlobalAxios.get<ICompanyDigitalCertificate>(
    COMPANY_DIGITAL_CERTIFICATE_SERVICE + id,
  );
};

export const updateCompanyDigitalCertificateById = ({
  item,
  id,
}: {
  item: INewCompanyDigitalCertificate;
  id: string;
}) => {
  return GlobalAxios.put(COMPANY_DIGITAL_CERTIFICATE_SERVICE + id, item);
};

export const companyDigitalCertificateList = (params?: any) => {
  return GlobalAxios.get<ICompanyDigitalCertificateList[]>(
    COMPANY_DIGITAL_CERTIFICATE_SERVICE + "list",
    {
      params,
    },
  );
};
